module.exports = __webpack_public_path__ + "img/borderPolygonWhite.a0383fac.svg";